<template>
    <div class="col-md-4">
      <div class="box box-primary">
        <div class="box-header with-border">
          <h5 v-if="prefix === 'shipping'" class="no-margin"><i class="fa fa-truck text-muted mr-5"></i>{{ 'shipping_address' | translate }}:
          </h5>
          <h5 v-if="prefix === 'return'" class="no-margin"><i class="fa fa-refresh text-muted mr-5"></i>{{'return_address'| translate}}:
          </h5>
          <h5 v-if="prefix === 'pickup'" class="no-margin"><i class="fa fa-map-marker text-muted mr-5"></i>PickUp-{{'address' | translate}}:
          </h5>
        </div>
        <div class="box-body">
          <div class="row">
            <div class="col-xs-12">
              <div class="form-group">
                <label for="shop_name">{{ 'shop_name' | translate }}:</label>
                <input id="shop_name" v-model="address[prefix + '_name']" v-validate="{required: true}" :data-vv-scope="prefix" placeholder="Filialname" type="text" class="form-control">
              </div>
            </div>
            <div class="col-sm-9 col-xs-12">
              <div class="form-group">
                <label for="street">{{'shipping_street' | translate}}:</label>
                <input id="street" v-model="address[prefix + '_street']" v-validate="{required: true}" :data-vv-scope="prefix" placeholder="Straße" type="text" class="form-control">
              </div>
            </div>
            <div class="col-sm-3 col-xs-12">
              <div class="form-group">
                <label for="street_number">Nr.:</label>
                <input id="street_number" v-validate="{required: true}" placeholder="Nr." :data-vv-scope="prefix" v-model="address[prefix + '_street_no']" type="text"  class="form-control">
              </div>
            </div>
            <div v-if="prefix === 'pickup'" class="col-xs-12">
              <div class="form-group">
                <label>{{'phone_number' | translate}}:</label>
                <input type="text" v-validate="{required: true}" name="pickup_phone" v-model="address[prefix + '_phone']" :data-vv-scope="prefix" class="form-control" placeholder="Number">
              </div>
            </div>
            <div class="col-sm-4 col-xs-12">
              <div class="form-group">
                <label for="zip_code">{{'shipping_zip_code' | translate}}:</label>
                <input id="zip_code" placeholder="Postleitzahl" v-validate="{required: true}" :data-vv-scope="prefix" v-model="address[prefix + '_zip_code']" type="text" class="form-control">
              </div>
            </div>
            <div class="col-sm-8 col-xs-12">
              <div class="form-group">
                <label for="city">{{'city' | translate}}</label>
                <input id="city" v-validate="{required: true}" v-model="address[prefix + '_city']" :data-vv-scope="prefix" placeholder="Ort" type="text" class="form-control">
              </div>
            </div>
            <div class="col-xs-12">
              <div class="form-group">
                <label for="country">{{'country' | translate}}:</label>
                <select id="country" v-model="address[prefix + '_country']"  :data-vv-scope="prefix" v-validate="{required: true}" class="form-control">
                  <option v-for="country in ['DE', 'AT', 'CH', 'NL', 'LU']" v-bind:key="country.id" :value="country">
                    {{ country.toLowerCase() | newCountry($store.getters.language) }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-xs-12">
              <span v-show="errors.any(prefix)" class="text-danger pull-right">{{ 'all_fields_required' | translate }}</span><br>
            </div>
          </div>
        </div>
        <div class="box-footer">
          <button v-if="prefix === 'shipping'" :disabled="errors.any(prefix)" @click="sendDataToParent();" class="btn btn-success btn-block btn-sm"><i class="fa fa-save mr-5"></i>{{'update_shipping_address' | translate}}</button>
          <button v-if="prefix === 'return'" :disabled="errors.any(prefix)" @click="sendDataToParent();" class="btn btn-success btn-block btn-sm"><i class="fa fa-save mr-5"></i>{{'update_return_address' | translate}}</button>
          <button v-if="prefix ==='pickup'" :disabled="errors.any(prefix)"  @click="sendDataToParent();" class="btn btn-success btn-block btn-sm"><i class="fa fa-save mr-5"></i>PickUp-{{'update_address' | translate}}</button>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: "StoreAdresses",
  props:['prefix', 'address'],
  methods:{
    sendDataToParent() {
      this.$validator.validate()
        .then(() => {
          if (!this.errors.any(this.prefix)) {
            this.address.prefix = this.prefix
            this.$emit('sendDataToParent', this.address)
          }
        })
    },
  },
  watch:{
    prefix: function(value){
      this.prefix = value
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/tools/StoreAdresses.vue